export const CREATE_APPLICATION = "CREATE_APPLICATION"
export const EDIT_APPLICATION = "EDIT_APPLICATION"
export const SET_CREATE_APPLICATION_STATUS = "SET_CREATE_APPLICATION_STATUS "
export const SET_EDIT_APPLICATION_STATUS = "SET_EDIT_APPLICATION_STATUS"
export const RESET_APPLICATION_RESPONSE_MSG = "RESET_APPLICATION_RESPONSE_MSG"
export const REGENERATE_APP_KEY = "REGENERATE_APP_KEY"
export const SET_REGENERATE_APP_KEY_STATUS = "SET_REGENERATE_APP_KEY_STATUS"
export const EDIT_ACCOUNT_SETTING = "EDIT_ACCOUNT_SETTING";
export const EDIT_ACCOUNT_SETTING_SUCCESS = "EDIT_ACCOUNT_SETTING_SUCCESS";
export const EDIT_ACCOUNT_SETTING_RESET = "EDIT_ACCOUNT_SETTING_RESET";
export const GET_ACCOUNT_SETTING = "GET_ACCOUNT_SETTING";
export const GET_ACCOUNT_SETTING_SUCCESS = "GET_ACCOUNT_SETTING_SUCCESS";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_RESET = "CHANGE_PASSWORD_RESET";
export const DELETE_APPLICATION = "DELETE_APPLICATION";
export const SET_DELETE_APPLICATION_STATUS = "SET_DELETE_APPLICATION_STATUS";
export const RESET_ACCOUNT_SETTING = "RESET_ACCOUNT_SETTING";
export const VERIFY_OTP = "VERIFY_OTP";
export const SET_OTP_STATUS = "SET_OTP_STATUS";
export const SET_TWO_FACTOR_AUTH_STATUS = "SET_TWO_FACTOR_AUTH_STATUS";
export const TOGGLE_TWO_FACTOR_AUTH = "TOGGLE_TWO_FACTOR_AUTH";
export const RESEND_OTP = "RESEND_OTP";
export const SET_RESEND_OTP_STATUS = "SET_RESEND_OTP_STATUS";
export const RESET_RESEND_OTP_RESPONSE_MSG = "RESET_RESEND_OTP_RESPONSE_MSG";
export const VERIFY_CURRENT_PASSWORD = "VERIFY_CURRENT_PASSWORD";
export const SET_VERIFY_CURRENT_PASSWORD_STATUS = "SET_VERIFY_CURRENT_PASSWORD_STATUS";
export const UPDATE_CONTACT_DETAILS = "UPDATE_CONTACT_DETAILS";
export const SET_UPDATE_CONTACT_DETAILS = "SET_UPDATE_CONTACT_DETAILS";
export const SEND_EMAIL = "SEND_EMAIL";
export const SET_SEND_EMAIL_STATUS = "SET_SEND_EMAIL_STATUS";
export const RESEND_LOGIN_OTP = "RESEND_LOGIN_OTP";
export const SET_RESEND_LOGIN_OTP_STATUS = "SET_RESEND_LOGIN_OTP_STATUS";
export const VERIFY_LOGIN_OTP = "VERIFY_LOGIN_OTP";
export const SET_LOGIN_OTP_STATUS = "SET_LOGIN_OTP_STATUS";
export const VERIFY_EMAIL = "VERIFY_EMAIL";
export const SET_VERIFY_EMAIL_STATUS = "SET_VERIFY_EMAIL_STATUS";







